import { render, staticRenderFns } from "./VideoIndex.vue?vue&type=template&id=6741bd87&scoped=true"
import script from "./VideoIndex.vue?vue&type=script&lang=js"
export * from "./VideoIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6741bd87",
  null
  
)

export default component.exports